import _ from 'lodash';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Modal } from '@treams/treams-ui';

import FeedbackLibraryAccordion from '../components/FeedbackLibraryAccordion';

type Props = {
	onCancel: () => void;
	onSelect: (questions: graphql.FeedbackQuestion[]) => void;
};

const SelectFeedbackQuestionTemplatesModal: FC<Props> = ({ onCancel, onSelect }) => {
	const { t } = useTranslation();
	const [selected, setSelected] = useState<graphql.FeedbackQuestion[]>([]);

	return (
		<Modal>
			<Modal.Header title={t('feedback.settings.template.questionSelector.title')} />
			<Modal.Contents>
				<FeedbackLibraryAccordion
					selectedQuestions={selected}
					onChangeSelectedQuestions={setSelected}
				/>
			</Modal.Contents>
			<Modal.FormFooter
				onCancel={onCancel}
				disabled={selected.length === 0}
				onSave={() => onSelect?.(_.sortBy(selected, 'order'))}
				saveTitle={t('feedback.settings.template.questionSelector.add')}
			/>
		</Modal>
	);
};

export default SelectFeedbackQuestionTemplatesModal;
